import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

// core components
import { BatchBody } from "frontend/components/fort/mod/core/Batch";

// components
import PhotoBatchGrid from "./PhotoBatchGrid";

// redux actions
import { setActiveView, setSavedView } from "../../slices/selectedBatchSlice";
import { fetchUploadsInBatch } from "../../slices/uploadsSlice";

import { useBatchUploads } from "../../hooks";

const PhotoModBatchBody = ({ batch, batchContentIsOpen }) => {
    const dispatch = useDispatch();

    const { id } = batch;
    const { currentView } = useSelector(state => state.selectedBatch);
    const { status: uploadsStatus } = useSelector(state => state.uploads);

    const {
        visModActiveIds,
        visModSavedIds,
        currentViewUploadIds
    } = useBatchUploads(id);

    const dispatchSetActiveView = () => {
        dispatch(setActiveView());
    };
    const dispatchSetSavedView = () => dispatch(setSavedView());

    useEffect(() => {
        if (batch.uploadsFetched) return;
        if (batchContentIsOpen) dispatch(fetchUploadsInBatch(id));
    }, [batchContentIsOpen, batch]);

    // TODO: Update when completing implementation of suspended queue batch grids
    let batchCollections = [
        {
            id: 1,
            title: "Visual Moderation",
            filter: {
                currentView: currentView,
                activeCount: visModActiveIds.length,
                savedCount: visModSavedIds.length,
                setActiveView: dispatchSetActiveView,
                setSavedView: dispatchSetSavedView
            },
            uploadIds: currentViewUploadIds
        }
    ];

    return (
        <BatchBody
            batch={batch}
            batchContentIsOpen={batchContentIsOpen}
            batchCollections={batchCollections}
            BatchGridComponent={PhotoBatchGrid}
            uploadsStatus={uploadsStatus}
        />
    );
};

// prop-types
PhotoModBatchBody.propTypes = {
    batch: PropTypes.object.isRequired,
    batchContentIsOpen: PropTypes.bool
};

export default PhotoModBatchBody;
